import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from '../../WifiConnect.module.scss';

export type PersonalTabDescription = {
  network_name: string;
};

export const PersonalTabDescription: React.FC<PersonalTabDescription> = ({
  network_name,
}) => {
  return (
    <div className="ray-grid__cell--span-full">
      <span>
        <FormattedMessage
          id="tabs.personal.description.message"
          defaultMessage="Use {network} network to connect your:"
          values={{ network: <b>{network_name}</b> }}
        />
      </span>
      <ul className={styles.devicesList}>
        <li>
          <span>
            <FormattedMessage
              id="tabs.personal.description.devices.0"
              defaultMessage="Personal computer or laptop"
            />
          </span>
        </li>
        <li>
          <span>
            <FormattedMessage
              id="tabs.personal.description.devices.1"
              defaultMessage="Smart phone"
            />
          </span>
        </li>
        <li>
          <span>
            <FormattedMessage
              id="tabs.personal.description.devices.2"
              defaultMessage="Smart tablet"
            />
          </span>
        </li>
        <li>
          <span>
            <FormattedMessage
              id="tabs.personal.description.devices.3"
              defaultMessage="Other similar devices"
            />
          </span>
        </li>
      </ul>
    </div>
  );
};
